import { connect } from 'react-redux';
import { convertToRaw, Draft } from '@ublend-npm/th90-editor';

import { operations } from '../../../../../store/materials';
import GetStarted from './GetStarted';
import * as appCreators from '../../../../../actions/materials';
import * as classRoomSelectors from '../../../../../../core/selectors/classroom';
import { hasDismissedGetStarted } from '../../../../../../core/materials/selectors';

const defaultContent = () => convertToRaw(Draft.EditorState.createEmpty());

const mapStateToProps = (state) => ({
  classRoom: state.classRoom.current,
  dismissed: hasDismissedGetStarted(state),
  user: state.user.user,
  editable: classRoomSelectors.isInstructor(state),
});

const mapDispatchToProps = (dispatch) => ({
  createSection: () =>
    dispatch(
      operations.createSection({
        content: defaultContent(),
        onSelect: appCreators.selectSectionInJourney,
      })
    ),
  dismiss: operations.dismissGetStarted(dispatch),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  dismiss: () => {
    dispatchProps.dismiss();
    dispatchProps.createSection(stateProps.classRoom, stateProps.user);
  },
});

const GetStartedContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(GetStarted);

export default GetStartedContainer;
